export default "__VITE_ASSET__BfeaCJsT__"